export function formatBytes(bytes, decimals = 2) {
  if (bytes === 0) return "0 Bytes";

  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

  const i = Math.floor(Math.log(bytes) / Math.log(k));

  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
}

export const numberToCurrency = (number, decimals = 2) => {
  return new Intl.NumberFormat("af", {
    style: "currency",
    currency: "ZAR",
    currencyDisplay: "narrowSymbol",
    minimumFractionDigits: decimals,
  }).format(number);
};

/** Sort array by Order field
 * @items - Give array containing order field.
 */
export const sortArray = (items) => {
  if (!items) {
    return [];
  }

  const timeScore = {
    "1-2 years": 1,
    "1-3 years": 2,
    "3+ years": 3,
    "3-4 years": 4,
    "4-5 years": 5,
    "5+ years": 6,
    "7+ years": 7,
  };

  const riskScore = {
    Low: 1,
    "Low-Medium": 2,
    "Moderately Conservative": 3,
    Moderate: 4,
    "Moderately Aggressive": 5,
    Aggressive: 6,
    "Medium-High": 6, // Treated similarly to Aggressive
    High: 7,
  };

  return items.sort((a, b) => {
    const aTime = timeScore[a.time] || 0;
    const bTime = timeScore[b.time] || 0;

    const aRisk = riskScore[a.risk] || 0;
    const bRisk = riskScore[b.risk] || 0;

    // Sort primarily by time, then by risk if time is equal
    if (aTime !== bTime) {
      return aTime - bTime;
    }

    return aRisk - bRisk;
  });
};

export const objectToArray = (item) => {
  let obj_array = [];

  const propertyNames = Object.keys(item);
  const propertyValues = Object.values(item);

  for (let i = 0; i < propertyNames.length; i++) {
    const key = propertyNames[i];
    const value = propertyValues[i];

    obj_array.push({ key, value });
  }

  return obj_array;
};

export const findInArray = (objectKey, myArray) => {
  for (var i = 0; i < myArray.length; i++) {
    if (myArray[i][objectKey] === objectKey) {
      return myArray[i];
    }
  }
};

export const checkObject = (obj) => {
  if (obj && Object.keys(obj).length > 0) {
    return true;
  } else {
    return false;
  }
};
